<form class="form vc-admin-form vc-admin-user-form" [formGroup]="form" (ngSubmit)="execute()" novalidate>
  @if (showIntro) {
    <header class="vc-admin-form__intro">
      <h3 class="vc-admin-form__title">{{ formTitleKey | translate }}</h3>
      <p class="vc-admin-form__subtitle">{{ formDescriptionKey | translate }}</p>
    </header>
  }

  @if (mode === 'create') {
  <section class="vc-admin-form__section">
    <h4 class="vc-admin-form__section-title">{{ 'ADMIN.USERS.INVITATION.TITLE' | translate }}</h4>
    <p class="vc-admin-form__section-subtitle">
      {{ 'ADMIN.USERS.INVITATION.DESCRIPTION' | translate }}
    </p>

    <div class="grid">
      <div class="col-12 md:col-6">
        <div class="field">
          <label for="email">{{ 'COMMON.EMAIL' | translate }} *</label>
          <input pInputText id="email" type="text" formControlName="email" fluid />
          <small class="vc-admin-form__field-hint">
            {{ 'ADMIN.USERS.INVITATION.EMAIL_HELP' | translate }}
          </small>
          <small id="user-email-help" class="p-error" *ngIf="hasFieldError('email')">
            {{ getFieldError('email') | translate }}
          </small>
        </div>
      </div>

      <div class="col-12 md:col-6">
        <div class="field">
          <label for="name">{{ 'ADMIN.USERS.INVITATION.DISPLAY_NAME' | translate }}</label>
          <input pInputText id="name" formControlName="name" fluid />
          <small class="vc-admin-form__field-hint">
            {{ 'ADMIN.USERS.INVITATION.DISPLAY_NAME_HELP' | translate }}
          </small>
        </div>
      </div>

      <div class="col-12 md:col-6">
        <div class="field">
          <label for="surname">{{ 'ADMIN.USERS.INVITATION.DISPLAY_SURNAME' | translate }}</label>
          <input pInputText id="surname" type="text" formControlName="surname" fluid />
        </div>
      </div>
    </div>
  </section>
  } @else if (showPersonalSection) {
  <section class="vc-admin-form__section">
    @if (showPersonalSectionHeader) {
      <h4 class="vc-admin-form__section-title">{{ 'ADMIN.USERS.PERSONAL.TITLE' | translate }}</h4>
      <p class="vc-admin-form__section-subtitle">{{ 'ADMIN.USERS.PERSONAL.DESCRIPTION' | translate }}</p>
    }

    <div class="grid">
      <div class="col-12 md:col-6">
        <div class="field">
          <label for="name">{{ 'COMMON.NAME' | translate }} *</label>
          <input pInputText id="name" formControlName="name" fluid />
          <small id="user-name-help" class="p-error" *ngIf="hasFieldError('name')">
            {{ getFieldError('name') | translate }}
          </small>
        </div>
      </div>

      <div class="col-12 md:col-6">
        <div class="field">
          <label for="surname">{{ 'COMMON.SURNAME' | translate }}</label>
          <input pInputText id="surname" type="text" formControlName="surname" fluid />
          <small id="user-surname-help" class="p-error" *ngIf="hasFieldError('surname')">
            {{ getFieldError('surname') | translate }}
          </small>
        </div>
      </div>

      <div class="col-12 md:col-6" *ngIf="!exclude.includes('email')">
        <div class="field">
          <label for="email">{{ 'COMMON.EMAIL' | translate }} *</label>
          <input pInputText id="email" type="text" formControlName="email" fluid />
          <small id="user-email-help" class="p-error" *ngIf="hasFieldError('email')">
            {{ getFieldError('email') | translate }}
          </small>
        </div>
      </div>

      <div class="col-12 md:col-6">
        <div class="field">
          <label for="birthday">{{ 'COMMON.BIRTHDAY' | translate }}</label>
          <p-datepicker
            dateFormat="dd/mm/yy"
            [firstDayOfWeek]="1"
            [maxDate]="maxBirthdayDate"
            [minDate]="minBirthdayDate"
            inputId="birthday"
            formControlName="birthday"
            fluid
          />
          <small class="vc-admin-form__field-hint">
            {{ 'ADMIN.USERS.PERSONAL.BIRTHDAY_HINT' | translate }}
          </small>
          <small id="user-birthday-help" class="p-error" *ngIf="hasFieldError('birthday')">
            {{ getFieldError('birthday') | translate }}
          </small>
        </div>
      </div>
    </div>
  </section>
  }

  @if (showEmployeeSection && mode === 'edit') {
  <section class="vc-admin-form__section">
    <h4 class="vc-admin-form__section-title">{{ 'ADMIN.USERS.EMPLOYEE.TITLE' | translate }}</h4>
    <p class="vc-admin-form__section-subtitle">{{ 'ADMIN.USERS.EMPLOYEE.DESCRIPTION' | translate }}</p>

    <div class="grid">
      <div class="col-12 md:col-6" *ngIf="!exclude.includes('job')">
        <div class="field">
          <label for="job">{{ 'COMMON.JOB' | translate }}</label>
          <p-select
            inputId="job"
            [options]="jobs"
            formControlName="job"
            optionLabel="name"
            [disabled]="jobs.length === 0"
            fluid
          />
          <small id="user-job-help" class="p-error" *ngIf="hasFieldError('job')">
            {{ getFieldError('job') | translate }}
          </small>
        </div>
      </div>

      <div class="col-12 md:col-6">
        <div class="field">
          <label for="hire_date">{{ 'COMMON.HIRE_DATE' | translate }}</label>
          <p-datepicker
            dateFormat="dd/mm/yy"
            [firstDayOfWeek]="1"
            [maxDate]="maxHireDate"
            [minDate]="form.controls['birthday'].value || null"
            inputId="hire_date"
            formControlName="hire_date"
            fluid
          />
          <small class="vc-admin-form__field-hint">
            {{ 'ADMIN.USERS.EMPLOYEE.HIRE_DATE_HINT' | translate }}
          </small>
          <small id="user-hire_date-help" class="p-error" *ngIf="hasFieldError('hire_date')">
            {{ getFieldError('hire_date') | translate }}
          </small>
        </div>
      </div>
    </div>
  </section>
  }

  @if (showCompensationSection && mode === 'edit') {
  <section class="vc-admin-form__section">
    <h4 class="vc-admin-form__section-title">{{ 'ADMIN.USERS.COMPENSATION.TITLE' | translate }}</h4>
    <p class="vc-admin-form__section-subtitle">{{ 'ADMIN.USERS.COMPENSATION.DESCRIPTION' | translate }}</p>

    <div class="vc-admin-compensation-grid">
      <label class="vc-admin-compensation-card">
        <input type="checkbox" formControlName="compensationFixedEnabled" />
        <div>
          <strong>{{ 'ADMIN.USERS.COMPENSATION.FIXED.TITLE' | translate }}</strong>
          <small>{{ 'ADMIN.USERS.COMPENSATION.FIXED.DESCRIPTION' | translate }}</small>
        </div>
      </label>

      @if (form.controls['compensationFixedEnabled'].value) {
        <div class="field">
          <label for="compensationFixedAnnual">{{ 'ADMIN.USERS.COMPENSATION.FIXED.AMOUNT' | translate }}</label>
          <input
            pInputText
            id="compensationFixedAnnual"
            type="number"
            min="0"
            formControlName="compensationFixedAnnual"
            fluid
          />
        </div>
      }

      <label class="vc-admin-compensation-card">
        <input type="checkbox" formControlName="compensationTreatmentEnabled" />
        <div>
          <strong>{{ 'ADMIN.USERS.COMPENSATION.TREATMENTS.TITLE' | translate }}</strong>
          <small>{{ 'ADMIN.USERS.COMPENSATION.TREATMENTS.DESCRIPTION' | translate }}</small>
        </div>
      </label>

      @if (form.controls['compensationTreatmentEnabled'].value) {
        <div class="field">
          <label for="compensationTreatmentPercent">
            {{ 'ADMIN.USERS.COMPENSATION.TREATMENTS.PERCENT' | translate }}
          </label>
          <input
            pInputText
            id="compensationTreatmentPercent"
            type="number"
            min="0"
            max="100"
            formControlName="compensationTreatmentPercent"
            fluid
          />
        </div>
      }

      <label class="vc-admin-compensation-card">
        <input type="checkbox" formControlName="compensationSalesEnabled" />
        <div>
          <strong>{{ 'ADMIN.USERS.COMPENSATION.SALES.TITLE' | translate }}</strong>
          <small>{{ 'ADMIN.USERS.COMPENSATION.SALES.DESCRIPTION' | translate }}</small>
        </div>
      </label>

      @if (form.controls['compensationSalesEnabled'].value) {
        <div class="field">
          <label for="compensationSalesPercent">
            {{ 'ADMIN.USERS.COMPENSATION.SALES.PERCENT' | translate }}
          </label>
          <input
            pInputText
            id="compensationSalesPercent"
            type="number"
            min="0"
            max="100"
            formControlName="compensationSalesPercent"
            fluid
          />
        </div>
      }
    </div>

    @if (compensationSummary.length > 0) {
      <div class="vc-admin-compensation-summary">
        <strong>{{ 'ADMIN.USERS.COMPENSATION.SUMMARY.TITLE' | translate }}</strong>
        <ul>
          @for (item of compensationSummary; track item) {
            <li>{{ item }}</li>
          }
        </ul>
      </div>
    } @else {
      <small class="vc-admin-form__field-hint">
        {{ 'ADMIN.USERS.COMPENSATION.SUMMARY.EMPTY' | translate }}
      </small>
    }
  </section>
  }

  @if (mode === 'create' && showCreateAccessSection) {
    <section class="vc-admin-form__section">
      <h4 class="vc-admin-form__section-title">
        {{ 'ADMIN.USERS.CREATE_ACCESS.TITLE' | translate }}
      </h4>
      <p class="vc-admin-form__section-subtitle">
        {{ 'ADMIN.USERS.CREATE_ACCESS.DESCRIPTION' | translate }}
      </p>

      @if (!loadingCostHint && costHint) {
        <div class="vc-admin-form__info">
          <i class="fas fa-euro-sign"></i>
          <p>
            @if (costHint.additional_charge) {
              {{
                'ADMIN.CUSTOMERS.COST_HINTS.USER_WITH_COST'
                  | translate: { amount: (costHint.effective_price | number: '1.2-2') }
              }}
            } @else {
              {{ 'ADMIN.CUSTOMERS.COST_HINTS.USER_NO_EXTRA' | translate }}
            }
          </p>
        </div>
      }

      <div class="vc-admin-form__warning">
        <i class="fas fa-triangle-exclamation"></i>
        <p>{{ 'ADMIN.USERS.CREATE_ACCESS.WARNING' | translate }}</p>
      </div>

      <div class="vc-admin-assignment-options">
        <label class="vc-admin-assignment-options__item" for="user-access-manual">
          <input
            id="user-access-manual"
            type="radio"
            name="userAccessMode"
            [checked]="accessMode === 'manual'"
            (change)="accessMode = 'manual'"
          />
          <span>
            <strong>{{ 'ADMIN.USERS.CREATE_ACCESS.MANUAL_TITLE' | translate }}</strong>
            <small>{{ 'ADMIN.USERS.CREATE_ACCESS.MANUAL_DESCRIPTION' | translate }}</small>
          </span>
        </label>

        <label class="vc-admin-assignment-options__item" for="user-access-all">
          <input
            id="user-access-all"
            type="radio"
            name="userAccessMode"
            [checked]="accessMode === 'all-clinics'"
            (change)="accessMode = 'all-clinics'"
          />
          <span>
            <strong>{{ 'ADMIN.USERS.CREATE_ACCESS.ALL_TITLE' | translate }}</strong>
            <small>{{ 'ADMIN.USERS.CREATE_ACCESS.ALL_DESCRIPTION' | translate }}</small>
          </span>
        </label>
      </div>

      @if (accessMode === 'all-clinics') {
        <div class="field mt-3">
          <label for="default-role">
            {{ 'ADMIN.USERS.CREATE_ACCESS.DEFAULT_ROLE' | translate }} *
          </label>
          <p-select
            inputId="default-role"
            [options]="roles"
            [(ngModel)]="defaultRoleId"
            [ngModelOptions]="{ standalone: true }"
            optionLabel="name"
            optionValue="id"
            appendTo="body"
            fluid
          ></p-select>
          <small class="p-error" *ngIf="accessErrors.defaultRole">
            {{ accessErrors.defaultRole }}
          </small>
        </div>
      }
    </section>
  }

  @if (!exclude.includes('password') && showCredentialsSection) {
    <section class="vc-admin-form__section">
      <h4 class="vc-admin-form__section-title">{{ 'ADMIN.USERS.CREDENTIALS' | translate }}</h4>

      <div class="grid">
        <div class="col-12 md:col-6">
          <div class="field">
            <label for="password">{{ 'COMMON.PASSWORD_NEW' | translate }} *</label>
            <p-password inputId="password" [feedback]="false" [toggleMask]="true" formControlName="password" fluid />
            <small id="user-password-help" class="p-error" *ngIf="hasFieldError('password')">
              {{ getFieldError('password') | translate }}
            </small>
          </div>
        </div>

        <div class="col-12 md:col-6">
          <div class="field">
            <label for="passwordRepeat">{{ 'COMMON.PASSWORD_REPEAT' | translate }} *</label>
            <p-password inputId="passwordRepeat" [feedback]="false" [toggleMask]="true" formControlName="passwordRepeat" fluid />
            <small id="user-password-confirm-help" class="p-error" *ngIf="hasFieldError('passwordRepeat')">
              {{ getFieldError('passwordRepeat') | translate }}
            </small>
          </div>
        </div>

        <div class="col-12">
          <app-admin-password-rules [password]="form.controls['password'].value || ''"></app-admin-password-rules>
        </div>
      </div>
    </section>
  }

  <app-admin-form-actions
    primaryLabelKey="COMMON.SAVE"
    [submitting]="submitting"
  ></app-admin-form-actions>
</form>
